import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Delete orchid pro reminder
 */
export default async function deleteOrchidProReminderById(
  reminderId: number,
  onBehalfOf?: string,
): Promise<AppointmentReminder> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/appointment_reminders/${reminderId}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "DELETE",
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
